import {
  MenuOutlined as MenuOutlinedIcon,
  LoyaltyOutlined as LoyaltyOutlinedIcon,
  MessageOutlined as MessageOutlinedIcon,
  TranslateOutlined as TranslateOutlinedIcon,
  CardMembershipOutlined as CardMembershipOutlinedIcon,
  HandshakeOutlined as HandshakeOutlinedIcon,
} from '@mui/icons-material';

const dashboard = {
  id: 'group-components',
  title: 'Components',
  type: 'group',
  children: [
    {
      id: 'menu',
      title: 'Menu',
      type: 'item',
      url: '/menu',
      icon: MenuOutlinedIcon,
    },
    {
      id: 'benefits',
      title: 'Benefits',
      type: 'item',
      url: '/benefits',
      icon: LoyaltyOutlinedIcon,
    },
    {
      id: 'statements',
      title: 'Statements',
      type: 'item',
      url: '/statements',
      icon: CardMembershipOutlinedIcon,
    },
    {
      id: 'messages',
      title: 'Messages',
      type: 'item',
      url: '/messages',
      icon: MessageOutlinedIcon,
    },
    {
      id: 'texts',
      title: 'Texts and translations',
      type: 'item',
      icon: TranslateOutlinedIcon,
      url: '/texts',
    },
    {
      id: 'sponsors',
      title: 'Sponsors',
      type: 'item',
      icon: HandshakeOutlinedIcon,
      url: '/sponsors',
    },
  ],
};

export default dashboard;
